export enum LOCAL_STORAGE_KEYS {
  HIDE_NOTIFICATION_BANNER = 'hide-notification-permission-banner',
  WIDGETS_CONFIG = 'widgets-config',
  WIDGETS_OVERLAY_DIMENSIONS = 'widgets-overlay-dimensions',
  DEFAULT_SELECTED_WIDGET_ID = 'default-selected-widget-id',
  RELATED_CALLS_ID = 'related-calls-id',
  RELATED_CALLS_LAST_CALL_WITH = 'related-calls-last-call-with',
}
